'use client';

import { useTranslations } from 'next-intl';
import Container from '@/components/ui/Container/Container';
import type { GroupCompanyData } from '@/types/group-company';
import GroupCompanyHeader from './GroupCompanyHeader';
import GroupCompanyCard from './GroupCompanyCard';

interface GroupCompanyProps {
  locale: string;
  data: GroupCompanyData | null;
}

export default function GroupCompany({ data }: GroupCompanyProps) {
  const t = useTranslations('groupCompany');

  if (!data) {
    return (
      <main className="min-h-screen bg-[#f6f5f1] font-figtree">
        <Container size="xl" as="section" className="py-20 pt-[150px]">
          <h1 className="text-3xl font-medium text-[#0a0a0a]">{t('error.title')}</h1>
          <p className="mt-4 text-lg text-gray-600">{t('error.message')}</p>
        </Container>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-[#f6f5f1] font-figtree lg:pt-[60px]">
      <Container size="xl" as="section" className="py-16 md:py-24">
        <GroupCompanyHeader title={data.pageTitle} subheading={data.pageSubheading} />
        <div className="mt-10 space-y-8 md:mt-12">
          {(data.groupItem ?? []).map((item, index) => (
            <GroupCompanyCard key={item.id} item={item} index={index} />
          ))}
        </div>
      </Container>
    </main>
  );
}
